<div class="container-tracker" [ngClass]="{ 'fordpass': isFordpass }">
    @for (step of listOfSteps(); track step.id; let isLast = $last) {
    <ng-container>
        <div class="step" [attr.class]="step.state" title="{{ step.label | translate }}">
            <span>{{ step.id }}</span>
        </div>

        @if (!isLast) {
        <div class="line-after-step"></div>
        }
    </ng-container>
    }

</div>